import React from 'react';
import { Helmet } from 'react-helmet';

const ProductSchema = ({ product }) => {
  if (!product) return null;

  // Calculate breadcrumbs
  const breadcrumbList = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Ana Sayfa",
      "item": "https://www.mrbrowncase.com"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Ürünler",
      "item": "https://www.mrbrowncase.com/products"
    }
  ];

  // Add collection to breadcrumbs if available
  if (product.collections && product.collections.name) {
    breadcrumbList.push({
      "@type": "ListItem",
      "position": 3,
      "name": product.collections.name,
      "item": `https://www.mrbrowncase.com/collections/${product.collections.id}`
    });
    
    breadcrumbList.push({
      "@type": "ListItem",
      "position": 4,
      "name": product.name,
      "item": `https://www.mrbrowncase.com/product/${product.id}`
    });
  } else {
    breadcrumbList.push({
      "@type": "ListItem",
      "position": 3,
      "name": product.name,
      "item": `https://www.mrbrowncase.com/product/${product.id}`
    });
  }

  // Sepet sayfasına URL oluştur
  const addToCartURL = `${window.location.origin}/products/${product.id}`;
  
  // Stok durumunu daima varsayılan olarak "stokta var" kabul edelim
  // Gerçek stok durumu ürün detay sayfasında model ve renk seçimine göre dinamik olarak belirleniyor
  const isInStock = true;

  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": product.images,
    "sku": `MRB-${product.id}`,
    "mpn": `MRB-${product.id}`,
    "brand": {
      "@type": "Brand",
      "name": "Mr. Brown Case"
    },
    "offers": {
      "@type": "Offer",
      "url": addToCartURL,
      "priceCurrency": "TRY",
      "price": product.price,
      "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      "itemCondition": "https://schema.org/NewCondition",
      "availability": isInStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "seller": {
        "@type": "Organization",
        "name": "Mr. Brown Case"
      }
    }
  };

  // Add compatible models if available
  if (product.phone_models && product.phone_models.length > 0) {
    schemaData.compatibleWith = product.phone_models.map(model => ({
      "@type": "Product",
      "name": model.brand ? `${model.brand} ${model.model_name || model.name}` : model.name
    }));
  }

  // Add reviews if available
  if (product.reviews && product.reviews.length > 0) {
    const avgRating = product.reviews.reduce((sum, review) => sum + review.rating, 0) / product.reviews.length;
    
    schemaData.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": avgRating.toFixed(1),
      "reviewCount": product.reviews.length
    };
    
    schemaData.review = product.reviews.slice(0, 3).map(review => ({
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": review.rating
      },
      "author": {
        "@type": "Person",
        "name": review.author_name || "Müşteri"
      },
      "reviewBody": review.content
    }));
  }

  // Breadcrumb schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbList
  };

  // Organization schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Mr. Brown Case",
    "url": "https://www.mrbrowncase.com",
    "logo": "https://www.mrbrowncase.com/logo512.png",
    "sameAs": [
      "https://www.instagram.com/mrbrowncase/",
      "https://www.facebook.com/mrbrowncase/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+90-xxx-xxx-xxxx",
      "contactType": "customer service",
      "availableLanguage": "Turkish"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default ProductSchema; 